import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LogosPraxis from "../../../assets/images/withdrawal-praxis.webp";
import LogoNeteller from "../../../assets/images/logo-neteller.webp";
import LogoSkrill from "../../../assets/images/logo-skrill.webp";
import { ReactComponent as IconArrow } from "../../../assets/icons/icon-arrow-summary.svg";
import { FaArrowLeft } from "react-icons/fa";


const UserWithdraw = () => {
  const { t } = useTranslation();
  const PAYMENT_METHODS=  [
      { title: t("Withdraw Crypto"), image: LogosPraxis, link: "#" },
      { title: t("Withdraw Neteller"), image: LogoNeteller, link: "#" },
      { title: t("Withdraw Skrill"), image: LogoSkrill, link: "#" },
    ];
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [selectedPayment, setSelectedPayment] = useState(null);
  return (
    <>
      {!selectedPayment ? (
        <div className="bg-[#636262] rounded-lg p-3">
          <div className="flex justify-between py-4" onClick={() => setIsOpen(!isOpen)}>
            {t("Withdraw via")}{" "}
            <span className={isOpen ? "rotate-360" : "rotate-180"}>
              <IconArrow />
            </span>
          </div>
          {isOpen && (
            <div className="flex flex-col space-y-2">
              {PAYMENT_METHODS.map((item, index) => {
                return (
                  <div
                    className="rounded bg-white p-3 hover:shadow-md hover:ring-2 hover:ring-primary cursor-pointer"
                    onClick={() => setSelectedPayment(item)}
                  >
                    <h4 className="text-[#4c4b4b]">{item.title}</h4>
                    <div className="flex justify-between w-full h-[45px]">
                      <img src={item.image} alt="payment method" className="max-w-[200px] max-h-[45px] h-[45px]" />
                      <button type="button" className="text-[#4c4b4b] text-sm font-semibold mt-3">
                        {t("WITHDRAW NOW")} <span className="text-primary text-lg font-normal"> &gt;</span>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ) : (
        <div className="bg-[#636262] p-3 -m-4 -ml-[20px]">
          <div className="flex  justify-between py-3">
            {t("Withdraw via")} | {selectedPayment.title}
            <span className="hover:text-primary flex gap-1 cursor-pointer text-sm font-normal" onClick={() => setSelectedPayment(null)}>
              <FaArrowLeft size={20} /> {t("Back to depost methods")}
            </span>
          </div>
          <div className="bg-white rounded-lg p-4 -mx-3 mt-3">
            <div className="flex justify-center">
              <img src={selectedPayment.image} alt="no image found" className="max-h-[60px] mb-4" />
            </div>
            <div className="flex flex-col w-full mb-5">
              <label className="text-black">{t("Amount *")}</label>
              <input
                type="number"
                className="border border-gray-600 bg-white text-black rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
              <small className="text-black">
                <strong className="text-black/60">{t("Min:")}</strong> $ 10.00 / <strong className="text-black/60">{t("Max:")}</strong> $ 2,000.00
              </small>
            </div>

            <div className="flex flex-col w-full">
              <label className="text-black">{t("Type")}</label>
              <select className="border w-full bg-white text-black rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-400">
                <option value="Any">{t("No withdraw")}</option>
              </select>
            </div>
            <button className="bg-primary text-white py-2 px-6 rounded-lg hover:bg-primary/70 transition disabled:opacity-50 disabled:cursor-not-allowed w-full mt-5">
              {loading ? "LOADING..." : "WITHDRAW"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UserWithdraw;
